import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Layout from '~/Components/Layout/Layout';
import { ProfileIcon, MailIcon } from '../../Components/Icons/Icons';
import RegisterShortcut from '../../Components/RegisterShortcut/RegisterShortcut';

import "./contact.scss";
import Translate from "~/Components/ContentTranslate/Translate";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

export const ContactForm = ({event, ...props}) => {

    return (
        <Layout colorBg page="contact-us">
            <div className="container">
                <div className="row no-gutters">
                    <div className="col-12">
                        <h2><TextTranslate name="word-contact-us" fallback="Contact Us"/></h2>
                    </div>
                    <div className="col-md-7 col-12 information">
                        <p><TextTranslate name="contact-msg-1" fallback="If you require further information about your experience or need assistance regarding the registration process, please email us directly and a member of the team will respond shortly."/></p>
                        <p><TextTranslate name="contact-msg-2" fallback=""/></p>
                    </div>
                    <div className="col-md-5 col-12 contacts">
                        <h4 className="d-md-none d-block text-primary text-uppercase mb-2"><TextTranslate name="word-our-team" fallback="Our Team"/></h4>

                        {!!event && event.contacts.map((contact, index) => (
                            <Fragment key={index}>
                                {index >= 1 && <hr className="d-none d-md-block"/>}
                                <div className="contacts__single">
                                    <h4><Translate model={contact} field="name" /></h4>
                                    <div><ProfileIcon/><p><Translate model={contact} field="title" /></p></div>
                                    <div><MailIcon/><p><Translate model={contact} field="email" /></p></div>
                                </div>
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>

            <RegisterShortcut />
        </Layout>
    );
}

const Contact = ({invitation}) => {
    return <ContactForm event={invitation?.event} />
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    invitation: state.invitation.data,
});

export default connect(mapStateToProps)(Contact);
